import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const TypeNestedDropdown = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
      <path d="M3 18H8V16H3V18ZM9.5 18H14.5V16H9.5V18ZM16 18H21V16H16V18ZM3 14H11V12H3V14ZM13 14H21V12H13V14ZM3 6V10H21V6H3Z" />
    </SvgIcon>
  )
);

TypeNestedDropdown.displayName = 'TypeNestedDropdown';

export default TypeNestedDropdown;
